export default "/048cb1f2b29308e18768c65cfd51e426596a830c/57a43ba76340ea303ae7dc89733370a0.svg";